// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("public/img/graph/graph-magnifier.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-side-panel__content {
  --panel-content-width: 401px;
  background: var(--lightgray-e);
  margin-left: calc(-1 * var(--panel-content-width));
  width: var(--panel-content-width);
  border-right: 1px solid #d6d6d6;
  transition: margin .3s;
}

.graph-side-panel__content--open {
  margin-left: 0;
}

.graph-side-panel__icons {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
  border-right: 1px solid #d6d6d6;
  width: 70px;
  position: relative;
}

.graph-side-panel__icon-wrapper {
  background: #323f46;
  margin-right: 5px;
}

.graph-side-panel__icon {
  cursor: pointer;
  padding-top: var(--base-sizes-5);
  padding-bottom: var(--base-sizes-5);
  border-bottom: 1px solid #d6d6d6;
}

.graph-side-panel__icon:hover:not(.graph-side-panel__icon--active) {
  --tw-bg-opacity: 1;
  background-color: rgb(214 214 214 / var(--tw-bg-opacity));
}

.graph-side-panel__icon:hover:not(.graph-side-panel__icon--active) .graph-side-panel__icon-hover {
  display: inline;
}

.graph-side-panel__icon:hover:not(.graph-side-panel__icon--active) .graph-side-panel__icon-default {
  display: none;
}

.graph-side-panel__icon-default, .graph-side-panel__icon-colored {
  display: inline;
}

.graph-side-panel__icon--active {
  --tw-bg-opacity: 1;
  background-color: rgb(102 112 133 / var(--tw-bg-opacity));
  color: #fff;
}

.graph-side-panel__icon-hover {
  display: none;
}

.graph-side-panel__toggle {
  border-width: var(--base-sizes-0);
  width: 100%;
  margin-bottom: var(--base-sizes-7);
  --tw-text-opacity: 1;
  color: rgb(140 140 140 / var(--tw-text-opacity));
  background-color: #0000;
  border-style: none;
  justify-content: center;
  transition: color .3s linear;
  display: flex;
}

.graph-side-panel__toggle:hover {
  --tw-text-opacity: 1;
  color: rgb(214 214 214 / var(--tw-text-opacity));
}

.graph-layout-settings__apply--transparent {
  background: none;
}

.graph-layout-settings-protocols__protocol {
  height: 47px;
}

.graph-layout-settings-protocols__protocol--hover:hover {
  background: #dcdcdc;
}

.graph-layout-settings-protocols__protocol--border-bottom:before {
  background: var(--lightgray-d);
  content: "";
  z-index: 0;
  height: 1px;
  line-height: 1px;
  position: absolute;
  top: 45px;
  left: 20px;
  right: 20px;
}

.graph-layout-settings-protocols__group--border {
  border: 1px dashed #ccc;
  position: relative;
}

.graph-layout-settings-protocols__color {
  width: 14px;
  height: 14px;
}

.graph-layout-settings-protocols__button, .graph-layout-settings-protocols__default-button {
  text-align: center;
  width: 24px;
  height: 24px;
  padding: 0;
  line-height: 24px;
}

.btn-group-xs > .btn.graph-layout-settings-protocols__button, .btn-group-xs > .graph-layout-settings-protocols__default-button {
  z-index: auto;
  outline: 0;
  padding: 0;
  font-size: 14px;
}

.graph-layout-settings-protocols__button--active, .graph-layout-settings-protocols__button--active:hover, .active.graph-layout-settings-protocols__button--active, .active.graph-layout-settings-protocols__button--active:focus, .graph-layout-settings-protocols__button--active:focus, .graph-layout-settings-protocols__button--hover:hover {
  color: #4593f7;
}

.graph-layout-settings-protocols__button--danger:hover, .graph-layout-settings-protocols__button--danger:hover:hover {
  color: var(--danger);
}

.graph-layout-settings__scroll > div {
  flex-direction: column;
  flex: 1;
  display: flex;
  overflow-x: auto !important;
}

.graph-layout-settings-protocol-options__label-settings {
  border-left: 1px solid #ddd;
}

.graph-layout-settings-protocol-options__thickness-wrapper {
  flex-shrink: 0;
  width: 30px;
  overflow: hidden;
}

.graph-layout-settings-protocol-options__thickness-wrapper-medium {
  border-radius: 1.5px;
  height: 3px;
}

.graph-layout-settings-protocol-options__thickness-wrapper-thick {
  border-radius: 2.5px;
  height: 5px;
}

.graph-layout-settings-protocol-options__thickness-wrapper-more {
  border-radius: 3.5px;
  height: 7px;
}

.graph-layout-settings-protocol-options__thickness {
  flex-shrink: 0;
  width: 30px;
  height: 0;
  display: block;
}

.graph-layout-settings-protocol-options__thickness-thin {
  border-bottom-width: 1px;
}

.graph-layout-settings-protocol-options__thickness-medium {
  border-bottom-width: 3px;
}

.graph-layout-settings-protocol-options__thickness-thick {
  border-bottom-width: 5px;
}

.graph-layout-settings-protocol-options__thickness-more {
  border-bottom-width: 7px;
}

.graph-layout-settings-protocol-options__stroke {
  border-bottom-width: 2px;
  border-bottom-color: #000;
  width: 60px;
  height: 1px;
}

.graph-layout-settings-protocol-options__style-arrow {
  color: var(--text-color);
}

.graph-layout-settings-protocol-options__line-width {
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
  display: inline-block;
}

.graph-layout-settings-edit__add-group, .graph-layout-settings-edit__lock {
  width: auto;
}

.graph-layout-settings-protocol-empty-group__wrapper {
  border: 1px dashed #d6d6d6;
  align-items: center;
  padding: 10px 10px 10px 8px;
  display: flex;
}

.graph-layout-settings-protocol-empty-group__boxes {
  height: 42px;
}

.graph-layout-settings-protocol-empty-group__drag-box {
  background: #cfcfcf;
  border-radius: 5px;
  width: 112px;
  height: 30px;
  position: absolute;
  top: 0;
  left: 0;
}

.graph-layout-settings-protocol-empty-group__hover-box {
  background: #f5f5f5;
  border-radius: 5px;
  width: 112px;
  height: 30px;
  padding: 6px;
  position: absolute;
  top: 12px;
  left: 12px;
  box-shadow: 2px 2px 10px #32323240;
}

.graph-layout-settings-protocol-empty-group__color {
  background: #d6d6d6;
  width: 10px;
  height: 10px;
  font-size: 10px;
  line-height: 10px;
}

.graph-layout-settings-protocol-empty-group__arrows {
  margin-bottom: -20px;
  font-size: 17.5px;
}

.graph-layout-settings-protocol-pane__close {
  background: var(--lightgray-e);
  padding: 0 20px;
}

.graph-layout-settings-devices__device {
  width: calc(50% - 10px);
}

.graph-layout-settings-devices__device:nth-of-type(odd) {
  margin-right: 10px;
}

.graph-layout-settings-devices__device:nth-of-type(2n) {
  margin-left: 10px;
}

.graph-layout-settings-devices__device-icon {
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  display: flex;
}

.graph-layout-settings__search {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 14px 6px no-repeat;
  padding-left: 37px;
}

.graph-layout-settings__search::placeholder {
  color: var(--text-color);
}

.tab-view.graph-side-panel-tabs-cards {
  --tab-view__content-background: var(--lightgray-e);
  --tab-view__active-tab-stripe-color: var(--blue-334);
  --tab-view__tab-font-color: var(--blue-bcc);
  --tab-view__tab-font-color--hover: #fff;
  --tab-view__tab-font-color--disabled: var(--blue-79a);
  padding-top: 15px;
  padding-bottom: 0;
}

.graph-side-panel-tabs-cards > .tab-view__content {
  flex-direction: column;
  display: flex;
}

.graph-side-panel-tabs-cards.tab-view > .nav-tabs .active a, .graph-side-panel-tabs-cards.tab-view > .nav-tabs .active a:hover, .graph-side-panel-tabs-cards.tab-view > .nav-tabs .active a:active, .graph-side-panel-tabs-cards.tab-view > .nav-tabs .active a:focus {
  border-left: 0;
  border-right: 0;
  padding-top: 9px;
}

.graph-side-panel__content .slide-pane {
  background: var(--lightgray-f);
  z-index: 2;
}

.graph-layout-settings-protocol-divider {
  border-color: #dcdcdc;
}

.graph-layout-settings-error-message {
  color: #333;
  align-items: center;
  display: flex;
}

.graph-layout-settings-error-message i {
  color: #dd4b3a;
}

.graph-side-panel-tabbed-content {
  --tw-bg-opacity: 1;
  background-color: rgb(102 112 133 / var(--tw-bg-opacity));
}

.tab-view__content.graph-side-panel-inner-tab {
  background: var(--lightgray-f);
}

.graph-pathlookup-expected-status-label {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  display: block;
}

.graph-pathlookup-checks-filter input[type="checkbox"] {
  margin: 0;
}

.graph-pathlookup-checks-filter label {
  align-items: center;
  height: 26px;
  margin-bottom: 0;
  display: flex;
}

.graph-pathlookup-expected-status-label--ok {
  background: #a8cb60;
}

.graph-pathlookup-expected-status-label--fail {
  background: #de392c;
}

.graph-pathlookup-divider {
  border-color: #d6d6d6;
}

.graph-pathlookup-define-button {
  color: #536584;
}

.graph-item-hr {
  position: relative;
}

.graph-item-hr:before {
  background: var(--lightgray-d);
  content: "";
  z-index: 0;
  height: 1px;
  line-height: 1px;
  position: absolute;
  top: 45px;
  left: 20px;
  right: 20px;
}

.graph-stp-instance {
  padding: 15px 0;
  font-size: 13px;
  position: relative;
}

.graph-stp-instance:before {
  background: var(--lightgray-d);
  content: "";
  z-index: 0;
  height: 1px;
  line-height: 1px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.graph-stp-instances {
  padding-left: 45px;
  font-size: 13px;
  position: relative;
}

.graph-stp-instances--open:before {
  background: var(--lightgray-d);
  content: "";
  z-index: 0;
  height: 1px;
  line-height: 1px;
  position: absolute;
  top: 0;
  left: 20px;
  right: 20px;
}

.graph-stp-instances__labels {
  padding-bottom: 5px;
  padding-right: 66px;
}

.graph-stp-instances__list {
  height: 252px;
}

.graph-stp-instances__vlan-filter {
  width: 129px;
}

.graph-stp-instances__toggle-button {
  text-align: left;
  background: none;
  border: none;
  outline: none;
  width: 270px;
  height: 45px;
  padding-left: 85px;
  position: absolute;
  top: -46px;
  left: 14px;
}

.graph-stp-instances__toggle-button-icon {
  margin-left: 10px;
}

.graph-stp-instance-vlan-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 110px;
  overflow: hidden;
}

.graph-stp-instance-root-hostname {
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 130px;
  overflow: hidden;
}

.network-viewer__change-layout-icon {
  display: inline;
  position: relative;
}

.network-viewer__change-layout-icon:after {
  --tw-content: "";
  content: var(--tw-content);
  position: absolute;
  inset: -7px;
}

.graph-preset-controls {
  background: var(--lightgray-f);
  justify-content: space-between;
}

.button.graph-preset-controls__button:not(.button--square) {
  min-width: 4.2rem;
}

.graph-side-panel-no-data__title {
  color: var(--lightgray-7);
  font-size: 20px;
}

.graph-side-panel-no-data__subtitle {
  color: var(--lightgray-7);
  font-size: 13px;
}

.graph-side-panel-no-data__button {
  color: var(--lightgray-7);
  text-decoration: underline;
}

.graph-side-panel-no-data__button:hover {
  color: var(--lightgray-7);
  text-decoration: none;
}

.graph-side-panel-no-data__icon {
  color: var(--lightgray-d);
}

.graph-side-panel-main-submit-button {
  justify-content: center;
  padding: 17.5px 10px;
  display: flex;
}

.graph-side-panel-main-submit-button--with-separator {
  border-top: 1px solid #ddd;
}

.graph-side-panel-main-submit-button--main-tab {
  background: var(--lightgray-e);
}

.graph-side-panel-main-submit-button--inner-tab, .graph-pathlookup__content {
  background: var(--lightgray-f);
}

.graph-pathlookup__tooltip-label {
  width: 90px;
  height: 45px;
}

.graph-pathlookup-data-input-tabs > .nav-tabs:not(.disable-style) {
  padding: 0 7.5px;
}

.graph-path-detected-state {
  background: #d6d6d6;
  border-radius: 9px;
  justify-content: center;
  align-items: center;
  width: 112px;
  height: 18px;
  font-size: 11px;
  font-weight: bold;
  transition: all .2s;
  display: flex;
}

.graph-path-detected-state--pass {
  color: #323232;
  background: #a8cb60;
}

.graph-path-detected-state--fail {
  color: #fff;
  background: #de392c;
}

.graph-pathlookup__path-check {
  border-top: 1px solid #dcdcdc;
}

.graph-pathlookup__section-label {
  font-size: 13px;
  font-weight: 700;
}

.graph-pathlookup__label {
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
}

.graph-pathlookup__see-all-checks {
  color: #536584;
  font-size: 13px;
  text-decoration: underline;
}

.graph-pathlookup__disabled-checks-explanation {
  font-size: 13px;
}

.graph-pathlookup__network-mode .formik-double-pole-switch {
  justify-content: center;
}

.graph-pathlookup__network-mode--error .formik-double-pole-switch__area {
  background: #de392c;
}

.graph-pathlookup-soft-error {
  margin-top: 6px;
  font-size: 13px;
}

.graph-pathlookup-soft-error svg {
  fill: #de392c;
}

.graph-pathlookup__network-mode--disabled .formik-double-pole-switch__area {
  background: #d6d6d6;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Graph/GraphSidePanel/GraphPathlookup/styles.css","webpack://./services/frontend/app/components/Graph/GraphSidePanel/GraphPathlookup/styles.css"],"names":[],"mappings":"AADA;ECEE,4BAA4B;EAC5B,8BAA8B;EAC9B,kDAAkD;EAClD,iCAAiC;EACjC,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,kCAAkC;EAClC,oBAAoB;EACpB,gDAAgD;EAChD,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,2EAA+E;EAC/E,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kDAAkD;EAClD,oDAAoD;EACpD,2CAA2C;EAC3C,uCAAuC;EACvC,qDAAqD;EACrD,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".graph-side-panel__content {\n  --panel-content-width: 401px;\n\n  background: var(--lightgray-e);\n  border-right: 1px solid #d6d6d6;\n  margin-left: calc(-1 * var(--panel-content-width));\n  transition: margin 0.3s ease;\n  width: var(--panel-content-width);\n}\n\n.graph-side-panel__content--open {\n  margin-left: 0;\n}\n\n.graph-side-panel__icons {\n  --tw-bg-opacity: 1;\n  background-color: rgb(245 245 245 / var(--tw-bg-opacity));\n\n  position: relative;\n  width: 70px;\n  border-right: 1px solid #d6d6d6;\n}\n\n.graph-side-panel__icon-wrapper {\n  background: #323f46;\n  margin-right: 5px;\n}\n\n.graph-side-panel__icon {\n  cursor: pointer;\n  padding-top: var(--base-sizes-5);\n  padding-bottom: var(--base-sizes-5);\n\n  border-bottom: 1px solid #d6d6d6;\n}\n\n.graph-side-panel__icon:hover:not(.graph-side-panel__icon--active) {\n  --tw-bg-opacity: 1;\n  background-color: rgb(214 214 214 / var(--tw-bg-opacity));\n}\n\n.graph-side-panel__icon:hover:not(.graph-side-panel__icon--active) .graph-side-panel__icon-hover {\n      display: inline;\n    }\n\n.graph-side-panel__icon:hover:not(.graph-side-panel__icon--active) .graph-side-panel__icon-default {\n      display: none;\n    }\n\n.graph-side-panel__icon-default,\n.graph-side-panel__icon-colored {\n  display: inline;\n}\n\n.graph-side-panel__icon--active {\n  --tw-bg-opacity: 1;\n  background-color: rgb(102 112 133 / var(--tw-bg-opacity));\n\n  color: #fff;\n}\n\n.graph-side-panel__icon-hover {\n  display: none;\n}\n\n.graph-side-panel__toggle {\n  border-width: var(--base-sizes-0);\n  border-style: none;\n  background-color: transparent;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: var(--base-sizes-7);\n  --tw-text-opacity: 1;\n  color: rgb(140 140 140 / var(--tw-text-opacity));\n\n  transition: color 300ms linear;\n}\n\n.graph-side-panel__toggle:hover {\n  --tw-text-opacity: 1;\n  color: rgb(214 214 214 / var(--tw-text-opacity));\n}\n\n.graph-layout-settings__apply--transparent {\n  background: transparent;\n}\n\n.graph-layout-settings-protocols__protocol {\n  height: 47px;\n}\n\n.graph-layout-settings-protocols__protocol--hover:hover {\n    background: #dcdcdc;\n  }\n\n.graph-layout-settings-protocols__protocol--border-bottom:before {\n    background: var(--lightgray-d);\n    content: '';\n    height: 1px;\n    left: 20px;\n    line-height: 1px;\n    position: absolute;\n    right: 20px;\n    top: 45px;\n    z-index: 0;\n  }\n\n.graph-layout-settings-protocols__group--border {\n  border: 1px dashed #ccc;\n  position: relative;\n}\n\n.graph-layout-settings-protocols__color {\n  width: 14px;\n  height: 14px;\n}\n\n.graph-layout-settings-protocols__button {\n  height: 24px;\n  line-height: 24px;\n  padding: 0;\n  text-align: center;\n  width: 24px;\n}\n\n.graph-layout-settings-protocols__default-button {\n  height: 24px;\n  line-height: 24px;\n  padding: 0;\n  text-align: center;\n  width: 24px;\n}\n\n/* TODO: will be deleted with Bootstrap */\n\n.btn-group-xs > .btn.graph-layout-settings-protocols__button,\n.btn-group-xs > .graph-layout-settings-protocols__default-button {\n  font-size: 14px;\n  padding: 0;\n  outline: 0;\n  z-index: auto;\n}\n\n.graph-layout-settings-protocols__button--active,\n.graph-layout-settings-protocols__button--active:hover,\n.active.graph-layout-settings-protocols__button--active,\n.active.graph-layout-settings-protocols__button--active:focus,\n.graph-layout-settings-protocols__button--active:focus {\n  color: #4593f7;\n}\n\n.graph-layout-settings-protocols__button--hover:hover {\n    color: #4593f7;\n  }\n\n.graph-layout-settings-protocols__button--danger:hover, .graph-layout-settings-protocols__button--danger:hover:hover {\n    color: var(--danger);\n  }\n\n.graph-layout-settings__scroll > div {\n  overflow-x: auto !important;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.graph-layout-settings-protocol-options__label-settings {\n  border-left: 1px solid #ddd;\n}\n\n.graph-layout-settings-protocol-options__thickness-wrapper {\n  flex-shrink: 0;\n  overflow: hidden;\n  width: 30px;\n}\n\n.graph-layout-settings-protocol-options__thickness-wrapper-medium {\n  height: 3px;\n  border-radius: 1.5px;\n}\n\n.graph-layout-settings-protocol-options__thickness-wrapper-thick {\n  height: 5px;\n  border-radius: 2.5px;\n}\n\n.graph-layout-settings-protocol-options__thickness-wrapper-more {\n  height: 7px;\n  border-radius: 3.5px;\n}\n\n.graph-layout-settings-protocol-options__thickness {\n  display: block;\n  flex-shrink: 0;\n  height: 0;\n  width: 30px;\n}\n\n.graph-layout-settings-protocol-options__thickness-thin {\n  border-bottom-width: 1px;\n}\n\n.graph-layout-settings-protocol-options__thickness-medium {\n  border-bottom-width: 3px;\n}\n\n.graph-layout-settings-protocol-options__thickness-thick {\n  border-bottom-width: 5px;\n}\n\n.graph-layout-settings-protocol-options__thickness-more {\n  border-bottom-width: 7px;\n}\n\n.graph-layout-settings-protocol-options__stroke {\n  width: 60px;\n  height: 1px;\n  border-bottom-width: 2px;\n  border-bottom-color: black;\n}\n\n.graph-layout-settings-protocol-options__style-arrow {\n  color: var(--text-color);\n}\n\n.graph-layout-settings-protocol-options__line-width {\n  border-bottom: 1px solid #ddd;\n  display: inline-block;\n  padding-bottom: 5px;\n}\n\n.graph-layout-settings-edit__add-group {\n  width: auto;\n}\n\n.graph-layout-settings-edit__lock {\n  width: auto;\n}\n\n.graph-layout-settings-protocol-empty-group__wrapper {\n  align-items: center;\n  border: 1px dashed #d6d6d6;\n  padding: 10px 10px 10px 8px;\n  display: flex;\n}\n\n.graph-layout-settings-protocol-empty-group__boxes {\n  height: 42px;\n}\n\n.graph-layout-settings-protocol-empty-group__drag-box {\n  background: #cfcfcf;\n  border-radius: 5px;\n  width: 112px;\n  height: 30px;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.graph-layout-settings-protocol-empty-group__hover-box {\n  background: #f5f5f5;\n  border-radius: 5px;\n  height: 30px;\n  left: 12px;\n  padding: 6px;\n  position: absolute;\n  top: 12px;\n  width: 112px;\n  box-shadow: 2px 2px 10px 0 rgba(50, 50, 50, 0.25);\n}\n\n.graph-layout-settings-protocol-empty-group__color {\n  background: #d6d6d6;\n  font-size: 10px;\n  height: 10px;\n  line-height: 10px;\n  width: 10px;\n}\n\n.graph-layout-settings-protocol-empty-group__arrows {\n  font-size: 17.5px;\n  margin-bottom: -20px;\n}\n\n.graph-layout-settings-protocol-pane__close {\n  background: var(--lightgray-e);\n  padding: 0 20px;\n}\n\n.graph-layout-settings-devices__device {\n  width: calc(50% - 10px);\n}\n\n.graph-layout-settings-devices__device:nth-of-type(odd) {\n    margin-right: 10px;\n  }\n\n.graph-layout-settings-devices__device:nth-of-type(even) {\n    margin-left: 10px;\n  }\n\n.graph-layout-settings-devices__device-icon {\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.graph-layout-settings__search {\n  background: url('public/img/graph/graph-magnifier.png') 14px 6px no-repeat\n    #fff;\n  padding-left: 37px;\n}\n\n.graph-layout-settings__search::placeholder {\n    color: var(--text-color);\n  }\n\n.tab-view.graph-side-panel-tabs-cards {\n  --tab-view__content-background: var(--lightgray-e);\n  --tab-view__active-tab-stripe-color: var(--blue-334);\n  --tab-view__tab-font-color: var(--blue-bcc);\n  --tab-view__tab-font-color--hover: #fff;\n  --tab-view__tab-font-color--disabled: var(--blue-79a);\n\n  padding-bottom: 0;\n  padding-top: 15px;\n}\n\n.graph-side-panel-tabs-cards > .tab-view__content {\n  display: flex;\n  flex-direction: column;\n}\n\n.graph-side-panel-tabs-cards.tab-view > .nav-tabs .active a,\n.graph-side-panel-tabs-cards.tab-view > .nav-tabs .active a:hover,\n.graph-side-panel-tabs-cards.tab-view > .nav-tabs .active a:active,\n.graph-side-panel-tabs-cards.tab-view > .nav-tabs .active a:focus {\n  border-left: 0;\n  border-right: 0;\n  padding-top: 9px;\n}\n\n.graph-side-panel__content .slide-pane {\n  background: var(--lightgray-f);\n  z-index: 2;\n}\n\n.graph-layout-settings-protocol-divider {\n  border-color: #dcdcdc;\n}\n\n.graph-layout-settings-error-message {\n  color: #333;\n  display: flex;\n  align-items: center;\n}\n\n.graph-layout-settings-error-message i {\n    color: #dd4b3a;\n  }\n\n.graph-side-panel-tabbed-content {\n  --tw-bg-opacity: 1;\n  background-color: rgb(102 112 133 / var(--tw-bg-opacity));\n}\n\n.tab-view__content.graph-side-panel-inner-tab {\n  background: var(--lightgray-f);\n}\n\n.graph-pathlookup-expected-status-label {\n  border-radius: 50%;\n  display: block;\n  height: 10px;\n  width: 10px;\n}\n\n.graph-pathlookup-checks-filter input[type='checkbox'] {\n    margin: 0;\n  }\n\n.graph-pathlookup-checks-filter label {\n    margin-bottom: 0;\n    height: 26px;\n    display: flex;\n    align-items: center;\n  }\n\n.graph-pathlookup-expected-status-label--ok {\n  background: #a8cb60;\n}\n\n.graph-pathlookup-expected-status-label--fail {\n  background: #de392c;\n}\n\n.graph-pathlookup-divider {\n  border-color: #d6d6d6;\n}\n\n.graph-pathlookup-define-button {\n  color: #536584;\n}\n\n.graph-item-hr {\n  position: relative;\n}\n\n.graph-item-hr:before {\n    background: var(--lightgray-d);\n    content: '';\n    height: 1px;\n    left: 20px;\n    line-height: 1px;\n    position: absolute;\n    right: 20px;\n    top: 45px;\n    z-index: 0;\n  }\n\n.graph-stp-instance {\n  font-size: 13px;\n  position: relative;\n  padding: 15px 0;\n}\n\n.graph-stp-instance:before {\n    background: var(--lightgray-d);\n    content: '';\n    height: 1px;\n    line-height: 1px;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 0;\n  }\n\n.graph-stp-instances {\n  padding-left: 45px;\n  font-size: 13px;\n  position: relative;\n}\n\n.graph-stp-instances--open:before {\n    background: var(--lightgray-d);\n    content: '';\n    height: 1px;\n    left: 20px;\n    line-height: 1px;\n    position: absolute;\n    right: 20px;\n    top: 0;\n    z-index: 0;\n  }\n\n.graph-stp-instances__labels {\n  padding-right: 66px;\n  padding-bottom: 5px;\n}\n\n.graph-stp-instances__list {\n  height: 252px;\n}\n\n.graph-stp-instances__vlan-filter {\n  width: 129px;\n}\n\n.graph-stp-instances__toggle-button {\n  position: absolute;\n  top: -46px;\n  left: 14px;\n  background: none;\n  border: none;\n  outline: none;\n  width: 270px;\n  text-align: left;\n  height: 45px;\n  padding-left: 85px;\n}\n\n.graph-stp-instances__toggle-button-icon {\n  margin-left: 10px;\n}\n\n.graph-stp-instance-vlan-name {\n  max-width: 110px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.graph-stp-instance-root-hostname {\n  max-width: 130px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.network-viewer__change-layout-icon {\n  position: relative;\n  display: inline;\n}\n\n.network-viewer__change-layout-icon:after {\n  position: absolute;\n  inset: -7px;\n  --tw-content: \"\";\n  content: var(--tw-content);\n}\n\n.graph-preset-controls {\n  background: var(--lightgray-f);\n  justify-content: space-between;\n}\n\n.button.graph-preset-controls__button:not(.button--square) {\n  min-width: 4.2rem;\n}\n\n.graph-side-panel-no-data__title {\n  font-size: 20px;\n  color: var(--lightgray-7);\n}\n\n.graph-side-panel-no-data__subtitle {\n  font-size: 13px;\n  color: var(--lightgray-7);\n}\n\n.graph-side-panel-no-data__button {\n  color: var(--lightgray-7);\n  text-decoration: underline;\n}\n\n.graph-side-panel-no-data__button:hover {\n    color: var(--lightgray-7);\n    text-decoration: none;\n  }\n\n.graph-side-panel-no-data__icon {\n  color: var(--lightgray-d);\n}\n\n.graph-side-panel-main-submit-button {\n  display: flex;\n  justify-content: center;\n  padding: 17.5px 10px;\n}\n\n/**\n * for submit buttons with tabbed content with different background above,\n * to make the background transition less disturbing.\n * Used the same color as nav-tabs border bottom to match the line\n * with upper border of inner tabs content.\n */\n\n.graph-side-panel-main-submit-button--with-separator {\n  border-top: 1px solid #ddd;\n}\n\n.graph-side-panel-main-submit-button--main-tab {\n  background: var(--lightgray-e);\n}\n\n.graph-side-panel-main-submit-button--inner-tab {\n  background: var(--lightgray-f);\n}\n\n.graph-pathlookup__content {\n  background: var(--lightgray-f);\n}\n\n.graph-pathlookup__tooltip-label {\n  height: 45px;\n  width: 90px;\n}\n\n.graph-pathlookup-data-input-tabs > .nav-tabs:not(.disable-style) {\n  padding: 0 7.5px;\n}\n\n.graph-path-detected-state {\n  width: 112px;\n  height: 18px;\n  border-radius: 9px;\n  background: #d6d6d6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: bold;\n  transition: all 200ms ease;\n}\n\n.graph-path-detected-state--pass {\n  background: #a8cb60;\n  color: #323232;\n}\n\n.graph-path-detected-state--fail {\n  background: #de392c;\n  color: #ffffff;\n}\n\n.graph-pathlookup__path-check {\n  border-top: 1px solid #dcdcdc;\n}\n\n.graph-pathlookup__section-label {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.graph-pathlookup__label {\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.graph-pathlookup__see-all-checks {\n  color: #536584;\n  text-decoration: underline;\n  font-size: 13px;\n}\n\n.graph-pathlookup__disabled-checks-explanation {\n  font-size: 13px;\n}\n\n.graph-pathlookup__network-mode .formik-double-pole-switch {\n    justify-content: center;\n  }\n\n.graph-pathlookup__network-mode--error .formik-double-pole-switch__area {\n    background: #de392c;\n  }\n\n.graph-pathlookup-soft-error {\n  font-size: 13px;\n  margin-top: 6px;\n}\n\n.graph-pathlookup-soft-error svg {\n    fill: #de392c;\n  }\n\n.graph-pathlookup__network-mode--disabled .formik-double-pole-switch__area {\n    background: #d6d6d6;\n  }\n",".graph-side-panel__content {\n  --panel-content-width: 401px;\n  background: var(--lightgray-e);\n  margin-left: calc(-1 * var(--panel-content-width));\n  width: var(--panel-content-width);\n  border-right: 1px solid #d6d6d6;\n  transition: margin .3s;\n}\n\n.graph-side-panel__content--open {\n  margin-left: 0;\n}\n\n.graph-side-panel__icons {\n  --tw-bg-opacity: 1;\n  background-color: rgb(245 245 245 / var(--tw-bg-opacity));\n  border-right: 1px solid #d6d6d6;\n  width: 70px;\n  position: relative;\n}\n\n.graph-side-panel__icon-wrapper {\n  background: #323f46;\n  margin-right: 5px;\n}\n\n.graph-side-panel__icon {\n  cursor: pointer;\n  padding-top: var(--base-sizes-5);\n  padding-bottom: var(--base-sizes-5);\n  border-bottom: 1px solid #d6d6d6;\n}\n\n.graph-side-panel__icon:hover:not(.graph-side-panel__icon--active) {\n  --tw-bg-opacity: 1;\n  background-color: rgb(214 214 214 / var(--tw-bg-opacity));\n}\n\n.graph-side-panel__icon:hover:not(.graph-side-panel__icon--active) .graph-side-panel__icon-hover {\n  display: inline;\n}\n\n.graph-side-panel__icon:hover:not(.graph-side-panel__icon--active) .graph-side-panel__icon-default {\n  display: none;\n}\n\n.graph-side-panel__icon-default, .graph-side-panel__icon-colored {\n  display: inline;\n}\n\n.graph-side-panel__icon--active {\n  --tw-bg-opacity: 1;\n  background-color: rgb(102 112 133 / var(--tw-bg-opacity));\n  color: #fff;\n}\n\n.graph-side-panel__icon-hover {\n  display: none;\n}\n\n.graph-side-panel__toggle {\n  border-width: var(--base-sizes-0);\n  width: 100%;\n  margin-bottom: var(--base-sizes-7);\n  --tw-text-opacity: 1;\n  color: rgb(140 140 140 / var(--tw-text-opacity));\n  background-color: #0000;\n  border-style: none;\n  justify-content: center;\n  transition: color .3s linear;\n  display: flex;\n}\n\n.graph-side-panel__toggle:hover {\n  --tw-text-opacity: 1;\n  color: rgb(214 214 214 / var(--tw-text-opacity));\n}\n\n.graph-layout-settings__apply--transparent {\n  background: none;\n}\n\n.graph-layout-settings-protocols__protocol {\n  height: 47px;\n}\n\n.graph-layout-settings-protocols__protocol--hover:hover {\n  background: #dcdcdc;\n}\n\n.graph-layout-settings-protocols__protocol--border-bottom:before {\n  background: var(--lightgray-d);\n  content: \"\";\n  z-index: 0;\n  height: 1px;\n  line-height: 1px;\n  position: absolute;\n  top: 45px;\n  left: 20px;\n  right: 20px;\n}\n\n.graph-layout-settings-protocols__group--border {\n  border: 1px dashed #ccc;\n  position: relative;\n}\n\n.graph-layout-settings-protocols__color {\n  width: 14px;\n  height: 14px;\n}\n\n.graph-layout-settings-protocols__button, .graph-layout-settings-protocols__default-button {\n  text-align: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  line-height: 24px;\n}\n\n.btn-group-xs > .btn.graph-layout-settings-protocols__button, .btn-group-xs > .graph-layout-settings-protocols__default-button {\n  z-index: auto;\n  outline: 0;\n  padding: 0;\n  font-size: 14px;\n}\n\n.graph-layout-settings-protocols__button--active, .graph-layout-settings-protocols__button--active:hover, .active.graph-layout-settings-protocols__button--active, .active.graph-layout-settings-protocols__button--active:focus, .graph-layout-settings-protocols__button--active:focus, .graph-layout-settings-protocols__button--hover:hover {\n  color: #4593f7;\n}\n\n.graph-layout-settings-protocols__button--danger:hover, .graph-layout-settings-protocols__button--danger:hover:hover {\n  color: var(--danger);\n}\n\n.graph-layout-settings__scroll > div {\n  flex-direction: column;\n  flex: 1;\n  display: flex;\n  overflow-x: auto !important;\n}\n\n.graph-layout-settings-protocol-options__label-settings {\n  border-left: 1px solid #ddd;\n}\n\n.graph-layout-settings-protocol-options__thickness-wrapper {\n  flex-shrink: 0;\n  width: 30px;\n  overflow: hidden;\n}\n\n.graph-layout-settings-protocol-options__thickness-wrapper-medium {\n  border-radius: 1.5px;\n  height: 3px;\n}\n\n.graph-layout-settings-protocol-options__thickness-wrapper-thick {\n  border-radius: 2.5px;\n  height: 5px;\n}\n\n.graph-layout-settings-protocol-options__thickness-wrapper-more {\n  border-radius: 3.5px;\n  height: 7px;\n}\n\n.graph-layout-settings-protocol-options__thickness {\n  flex-shrink: 0;\n  width: 30px;\n  height: 0;\n  display: block;\n}\n\n.graph-layout-settings-protocol-options__thickness-thin {\n  border-bottom-width: 1px;\n}\n\n.graph-layout-settings-protocol-options__thickness-medium {\n  border-bottom-width: 3px;\n}\n\n.graph-layout-settings-protocol-options__thickness-thick {\n  border-bottom-width: 5px;\n}\n\n.graph-layout-settings-protocol-options__thickness-more {\n  border-bottom-width: 7px;\n}\n\n.graph-layout-settings-protocol-options__stroke {\n  border-bottom-width: 2px;\n  border-bottom-color: #000;\n  width: 60px;\n  height: 1px;\n}\n\n.graph-layout-settings-protocol-options__style-arrow {\n  color: var(--text-color);\n}\n\n.graph-layout-settings-protocol-options__line-width {\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 5px;\n  display: inline-block;\n}\n\n.graph-layout-settings-edit__add-group, .graph-layout-settings-edit__lock {\n  width: auto;\n}\n\n.graph-layout-settings-protocol-empty-group__wrapper {\n  border: 1px dashed #d6d6d6;\n  align-items: center;\n  padding: 10px 10px 10px 8px;\n  display: flex;\n}\n\n.graph-layout-settings-protocol-empty-group__boxes {\n  height: 42px;\n}\n\n.graph-layout-settings-protocol-empty-group__drag-box {\n  background: #cfcfcf;\n  border-radius: 5px;\n  width: 112px;\n  height: 30px;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.graph-layout-settings-protocol-empty-group__hover-box {\n  background: #f5f5f5;\n  border-radius: 5px;\n  width: 112px;\n  height: 30px;\n  padding: 6px;\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  box-shadow: 2px 2px 10px #32323240;\n}\n\n.graph-layout-settings-protocol-empty-group__color {\n  background: #d6d6d6;\n  width: 10px;\n  height: 10px;\n  font-size: 10px;\n  line-height: 10px;\n}\n\n.graph-layout-settings-protocol-empty-group__arrows {\n  margin-bottom: -20px;\n  font-size: 17.5px;\n}\n\n.graph-layout-settings-protocol-pane__close {\n  background: var(--lightgray-e);\n  padding: 0 20px;\n}\n\n.graph-layout-settings-devices__device {\n  width: calc(50% - 10px);\n}\n\n.graph-layout-settings-devices__device:nth-of-type(odd) {\n  margin-right: 10px;\n}\n\n.graph-layout-settings-devices__device:nth-of-type(2n) {\n  margin-left: 10px;\n}\n\n.graph-layout-settings-devices__device-icon {\n  justify-content: center;\n  align-items: center;\n  width: 44px;\n  height: 44px;\n  display: flex;\n}\n\n.graph-layout-settings__search {\n  background: #fff url(\"public/img/graph/graph-magnifier.png\") 14px 6px no-repeat;\n  padding-left: 37px;\n}\n\n.graph-layout-settings__search::placeholder {\n  color: var(--text-color);\n}\n\n.tab-view.graph-side-panel-tabs-cards {\n  --tab-view__content-background: var(--lightgray-e);\n  --tab-view__active-tab-stripe-color: var(--blue-334);\n  --tab-view__tab-font-color: var(--blue-bcc);\n  --tab-view__tab-font-color--hover: #fff;\n  --tab-view__tab-font-color--disabled: var(--blue-79a);\n  padding-top: 15px;\n  padding-bottom: 0;\n}\n\n.graph-side-panel-tabs-cards > .tab-view__content {\n  flex-direction: column;\n  display: flex;\n}\n\n.graph-side-panel-tabs-cards.tab-view > .nav-tabs .active a, .graph-side-panel-tabs-cards.tab-view > .nav-tabs .active a:hover, .graph-side-panel-tabs-cards.tab-view > .nav-tabs .active a:active, .graph-side-panel-tabs-cards.tab-view > .nav-tabs .active a:focus {\n  border-left: 0;\n  border-right: 0;\n  padding-top: 9px;\n}\n\n.graph-side-panel__content .slide-pane {\n  background: var(--lightgray-f);\n  z-index: 2;\n}\n\n.graph-layout-settings-protocol-divider {\n  border-color: #dcdcdc;\n}\n\n.graph-layout-settings-error-message {\n  color: #333;\n  align-items: center;\n  display: flex;\n}\n\n.graph-layout-settings-error-message i {\n  color: #dd4b3a;\n}\n\n.graph-side-panel-tabbed-content {\n  --tw-bg-opacity: 1;\n  background-color: rgb(102 112 133 / var(--tw-bg-opacity));\n}\n\n.tab-view__content.graph-side-panel-inner-tab {\n  background: var(--lightgray-f);\n}\n\n.graph-pathlookup-expected-status-label {\n  border-radius: 50%;\n  width: 10px;\n  height: 10px;\n  display: block;\n}\n\n.graph-pathlookup-checks-filter input[type=\"checkbox\"] {\n  margin: 0;\n}\n\n.graph-pathlookup-checks-filter label {\n  align-items: center;\n  height: 26px;\n  margin-bottom: 0;\n  display: flex;\n}\n\n.graph-pathlookup-expected-status-label--ok {\n  background: #a8cb60;\n}\n\n.graph-pathlookup-expected-status-label--fail {\n  background: #de392c;\n}\n\n.graph-pathlookup-divider {\n  border-color: #d6d6d6;\n}\n\n.graph-pathlookup-define-button {\n  color: #536584;\n}\n\n.graph-item-hr {\n  position: relative;\n}\n\n.graph-item-hr:before {\n  background: var(--lightgray-d);\n  content: \"\";\n  z-index: 0;\n  height: 1px;\n  line-height: 1px;\n  position: absolute;\n  top: 45px;\n  left: 20px;\n  right: 20px;\n}\n\n.graph-stp-instance {\n  padding: 15px 0;\n  font-size: 13px;\n  position: relative;\n}\n\n.graph-stp-instance:before {\n  background: var(--lightgray-d);\n  content: \"\";\n  z-index: 0;\n  height: 1px;\n  line-height: 1px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.graph-stp-instances {\n  padding-left: 45px;\n  font-size: 13px;\n  position: relative;\n}\n\n.graph-stp-instances--open:before {\n  background: var(--lightgray-d);\n  content: \"\";\n  z-index: 0;\n  height: 1px;\n  line-height: 1px;\n  position: absolute;\n  top: 0;\n  left: 20px;\n  right: 20px;\n}\n\n.graph-stp-instances__labels {\n  padding-bottom: 5px;\n  padding-right: 66px;\n}\n\n.graph-stp-instances__list {\n  height: 252px;\n}\n\n.graph-stp-instances__vlan-filter {\n  width: 129px;\n}\n\n.graph-stp-instances__toggle-button {\n  text-align: left;\n  background: none;\n  border: none;\n  outline: none;\n  width: 270px;\n  height: 45px;\n  padding-left: 85px;\n  position: absolute;\n  top: -46px;\n  left: 14px;\n}\n\n.graph-stp-instances__toggle-button-icon {\n  margin-left: 10px;\n}\n\n.graph-stp-instance-vlan-name {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 110px;\n  overflow: hidden;\n}\n\n.graph-stp-instance-root-hostname {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 130px;\n  overflow: hidden;\n}\n\n.network-viewer__change-layout-icon {\n  display: inline;\n  position: relative;\n}\n\n.network-viewer__change-layout-icon:after {\n  --tw-content: \"\";\n  content: var(--tw-content);\n  position: absolute;\n  inset: -7px;\n}\n\n.graph-preset-controls {\n  background: var(--lightgray-f);\n  justify-content: space-between;\n}\n\n.button.graph-preset-controls__button:not(.button--square) {\n  min-width: 4.2rem;\n}\n\n.graph-side-panel-no-data__title {\n  color: var(--lightgray-7);\n  font-size: 20px;\n}\n\n.graph-side-panel-no-data__subtitle {\n  color: var(--lightgray-7);\n  font-size: 13px;\n}\n\n.graph-side-panel-no-data__button {\n  color: var(--lightgray-7);\n  text-decoration: underline;\n}\n\n.graph-side-panel-no-data__button:hover {\n  color: var(--lightgray-7);\n  text-decoration: none;\n}\n\n.graph-side-panel-no-data__icon {\n  color: var(--lightgray-d);\n}\n\n.graph-side-panel-main-submit-button {\n  justify-content: center;\n  padding: 17.5px 10px;\n  display: flex;\n}\n\n.graph-side-panel-main-submit-button--with-separator {\n  border-top: 1px solid #ddd;\n}\n\n.graph-side-panel-main-submit-button--main-tab {\n  background: var(--lightgray-e);\n}\n\n.graph-side-panel-main-submit-button--inner-tab, .graph-pathlookup__content {\n  background: var(--lightgray-f);\n}\n\n.graph-pathlookup__tooltip-label {\n  width: 90px;\n  height: 45px;\n}\n\n.graph-pathlookup-data-input-tabs > .nav-tabs:not(.disable-style) {\n  padding: 0 7.5px;\n}\n\n.graph-path-detected-state {\n  background: #d6d6d6;\n  border-radius: 9px;\n  justify-content: center;\n  align-items: center;\n  width: 112px;\n  height: 18px;\n  font-size: 11px;\n  font-weight: bold;\n  transition: all .2s;\n  display: flex;\n}\n\n.graph-path-detected-state--pass {\n  color: #323232;\n  background: #a8cb60;\n}\n\n.graph-path-detected-state--fail {\n  color: #fff;\n  background: #de392c;\n}\n\n.graph-pathlookup__path-check {\n  border-top: 1px solid #dcdcdc;\n}\n\n.graph-pathlookup__section-label {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.graph-pathlookup__label {\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.graph-pathlookup__see-all-checks {\n  color: #536584;\n  font-size: 13px;\n  text-decoration: underline;\n}\n\n.graph-pathlookup__disabled-checks-explanation {\n  font-size: 13px;\n}\n\n.graph-pathlookup__network-mode .formik-double-pole-switch {\n  justify-content: center;\n}\n\n.graph-pathlookup__network-mode--error .formik-double-pole-switch__area {\n  background: #de392c;\n}\n\n.graph-pathlookup-soft-error {\n  margin-top: 6px;\n  font-size: 13px;\n}\n\n.graph-pathlookup-soft-error svg {\n  fill: #de392c;\n}\n\n.graph-pathlookup__network-mode--disabled .formik-double-pole-switch__area {\n  background: #d6d6d6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
